export const getMedicalRoutes = () => [];
